import { render, staticRenderFns } from "./TeamRegionsOverview.vue?vue&type=template&id=c5dac88c&scoped=true&"
import script from "./TeamRegionsOverview.vue?vue&type=script&lang=js&"
export * from "./TeamRegionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./TeamRegionsOverview.vue?vue&type=style&index=0&id=c5dac88c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dac88c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5dac88c')) {
      api.createRecord('c5dac88c', component.options)
    } else {
      api.reload('c5dac88c', component.options)
    }
    module.hot.accept("./TeamRegionsOverview.vue?vue&type=template&id=c5dac88c&scoped=true&", function () {
      api.rerender('c5dac88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamRegions/TeamRegionsOverview.vue"
export default component.exports